const LOCAL_DIRECT_LINE_DOMAIN = 'http://localhost:3002/v3/directline';
const PUBLIC_DIRECT_LINE_DOMAIN =
  'https://northamerica.directline.botframework.com/v3/directline';

export const isUsingLocalDirectLine = () => {
  return Boolean(process.env.USE_LOCAL_DIRECTLINE);
};

export const getDirectLineDomain = () => {
  return isUsingLocalDirectLine()
    ? LOCAL_DIRECT_LINE_DOMAIN
    : PUBLIC_DIRECT_LINE_DOMAIN;
};
